var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1263 103L1263 131",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1263.5,
    cy: 98.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.99 98.1898C1258.99 94.2835 1262.29 91.1168 1266.36 91.1168C1266.94 91.1168 1267.51 91.1841 1268.06 91.3076C1266.74 90.4804 1265.19 90 1263.52 90C1258.81 90 1255 93.8056 1255 98.5C1255 103.194 1258.81 107 1263.52 107C1265.81 107 1267.89 106.093 1269.43 104.62C1268.49 105.032 1267.45 105.263 1266.36 105.263C1262.29 105.263 1258.99 102.096 1258.99 98.1898Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1272.4 97.6003L1272.37 95.1461L1270.54 96.7189L1268.3 96.0564L1269.11 98.3367L1267.77 100.381L1270.1 100.218L1271.5 102.144L1272.13 99.7627L1274.34 98.9085L1272.4 97.6003Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.b7f1004095b7c5db331a8c34ba1331a2.svg";
export { ForwardRef as ReactComponent };